(function () {
    const btns = document.querySelectorAll('[data-video]');
    if (btns.length === 0) return;

    const playVideo = (el) => {
        const videoEl = el.querySelector('video');
        if (videoEl) videoEl.play();
    }

    const stopVideo = (el) => {
        const videoEl = el.querySelector('video');
        if (videoEl) videoEl.pause();
    }

    btns.forEach(btn => {
        btn.addEventListener('mouseover', (e) => {
            playVideo(btn)
        })

        btn.addEventListener('mouseout', (e) => {
            stopVideo(btn)
        })
    })
})()